import theme from "../../theme";
import * as S from "./styled";
interface CardsProps {
    title: string;
    price: string;
    img?: any;
    onClick?: () => void;
}

export default function CardList({ price, title, img, onClick }: CardsProps) {

    return (
        <S.Container onClick={onClick}>

            <S.SubContainer>
                <S.Content>
                    {img && <S.Logo src={img} alt="right" />}

                    <S.Title>
                        {title}
                    </S.Title>
                </S.Content>


                <S.Price style={{ color: img && theme.COLORS.ERROR }} >
                    {price}
                </S.Price>
            </S.SubContainer>

        </S.Container>
    );
}
